
<template>
  <div class="wrap">
     
   <div class="head" v-if="swiperState == 1 || !bodyInfo">
        <div>
            <a v-if="this.$store.state.userName == ''" :href="`http://passport.ourgame.com/passportlogin.do?from=star&nexturl=${this.service_url}${encodeURIComponent('/PrecreateFamily/index.html#/')}`">亲爱的仙友，请先  登录</a>
            <span v-if="this.$store.state.userName != ''">{{this.$store.state.userName}}{{this.$store.state.roleName}}</span>
            <a style="padding-left:30px;" v-if="this.$store.state.userName != ''" :href="`http://passport.ourgame.com/lzgamelogout!webhall.do?nexturl=${this.service_url}${encodeURIComponent('/PrecreateFamily/index.html#/')}`">退出</a>
            /
            <a target="_blank" href="http://fmz.ourgame.com">官网</a>
            /
            <a target="_blank" href="">注册</a>
            /
            <a target="_blank"  href="http://fmz.ourgame.com/contents/22/240.html">下载</a>
            /
            <a target="_blank" href="http://bbs.lianzhong.com/showforum-10161.aspx">论坛</a>
        </div>
    </div>
    <swiper class="swiper-no-swiping" :options="swiperOption" @slidePrevTransitionEnd="slidePrevTransitionEnd" @slideNextTransitionEnd="slideNextTransitionEnd" @slideChange="slideChange" ref="mySwiper">

      <!-- slides -->
         
          <!-- {{activlianState}} -->
      <swiper-slide  v-if="activlianState == 1">
          <empty></empty>
      </swiper-slide>
        <swiper-slide v-if="activlianState == 2">
              <indexcompon @slideTo="slideTo" ></indexcompon>
        </swiper-slide>
      <swiper-slide><joinZongmen  ref="joinZongmen"></joinZongmen></swiper-slide>
      <swiper-slide><activityReward></activityReward></swiper-slide>
      <swiper-slide><activityRules></activityRules></swiper-slide>
    </swiper> 
  
    <div class="footer" v-if="swiperState == 2 || !bodyInfo">
              <!-- {{swiperActiveIndex}} -->
       <ul class="mauto">
           <li  v-for="(item,index) in navList" :class="swiperActiveIndex==(index+1)?'checkedNav':''"  @click="slideToFn(item,index)" :key="index">{{item.name}}</li>
       </ul>
    </div>
  </div>
</template>
 
<script>
import indexcompon from '@/components/index'
import joinZongmen from '@/components/joinZongmen'
import activityReward from '@/components/activityReward'
import activityRules from '@/components/activityRules'
import empty from '@/components/empty'
 import { swiper, swiperSlide } from 'vue-awesome-swiper'
 import { GetBindRoleInfo ,IsHasFamily} from '@/untils/authority'
const vm = this
export default {
  name: "home",
  components:{
    indexcompon,
    joinZongmen,
    activityReward,
    activityRules,
    empty,
     swiper,
	    swiperSlide
  },

  data() {
    return {
      swiperActiveIndex:-1,
      activlianState:1,
                    service_url: process.env.VUE_APP_current_URL
        ? process.env.VUE_APP_current_URL
        : "",
      navList:[
          {
              name:'创建宗门',
          },
          {
              name:'加入宗门',
          },
          {
              name:'活动奖励',
          },
          {
              name:'活动规则',
          },
      ],
      swiperState:1,
    
      bodyInfo:false,
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        // direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状 
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        loop:true,
        mousewheelControl: true, //同上
        height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        on: {
            //  2. 在滚动事件中通过上面保存的swiper元素获取当前页索引,可以打印一下c_swiper看一下内部属性
           slideChange:function (){
            //    console.log(vm)
            //    vm.swiperActiveIndex = this.activeIndex
            //    console.log()
           },
        
        }
      }
    };
  },
//   computed: {
//     swiper() {
//       return this.$refs.mySwiper.swiper;
//     }
//   },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    this.loginUrl = `http://passport.ourgame.com/lzgamelogout!webhall.do?nexturl=${this.service_url}${encodeURIComponent('/PrecreateFamily/index.html#/')}`
    if(document.body.offsetWidth<1920){
            this.bodyInfo = true
        }
 
  },
  methods:{
      slideTo(){
           this.$refs.joinZongmen.GetFamilyListFn();
          this.swiperActiveIndex = 2
          this.$refs.mySwiper.swiper.slideTo(2)
         
      },
      slideToFn(item,index){
        //   console.log(item.name)
        //   debugger
     
          if(item.name == '创建宗门'){
            //   this.activlianState = 2/
            //   this.$set(this.activlianState,2)
              this.activlianState = 1
               this.GetBindRoleInfoFn()
         
            
                
               
                // this.slideToFn(item,index)
            //  this.$forceUpdate()
          }else{
              this.activlianState = 1
             this.$refs.mySwiper.swiper.slideTo(index+1)
          }
           
      
      
      },
         slidePrevTransitionEnd(){
            console.log('pre');
            this.swiperState = 1
        },
        slideNextTransitionEnd(){
            console.log('next');
            this.swiperState = 2
        },
            // 是否绑定角色
        GetBindRoleInfoFn(){
            GetBindRoleInfo().then(response => {
                if(response.result == 1){
                    IsHasFamily().then(response => {
                        var res = response
                        if(response.result == 1){
                                    this.$nextTick(() => {
                                    this.activlianState = 2
                                    this.swiperActiveIndex = 1
                                    
                                })
                                this.$refs.mySwiper.swiper.slideTo(1)
                                this.$store.commit('SET_ROLENAME', res.data.roleName)
                        }else{
                            alert(response.message)
                        }
                    })

                }else if(response.result == 0){
                    alert('未登录，请先登录联众账号')
                    location.href = `http://passport.ourgame.com/lzgamelogin!webhallb.do?from=video&nexturl=`+location.href
                }else if(response.result == 2){
                     this.$nextTick(() => {
                        this.activlianState = 2
                        this.swiperActiveIndex = 1
                    
                     })
                     this.$refs.mySwiper.swiper.slideTo(1)
                    this.bindState = true
                }else{
                    alert(response.message)
                }
            })
        },
      slideChange(){
          console.log(this.$refs.mySwiper.swiper.activeIndex)
          if(this.$refs.mySwiper.swiper.activeIndex == 0){
              this.swiperActiveIndex = 4
              return 1
          }
          if(this.$refs.mySwiper.swiper.activeIndex>4){
              this.swiperActiveIndex = -1
          }else{
              this.activlianState = 1
            if(this.$refs.mySwiper.swiper.activeIndex == 1){
                 this.swiperActiveIndex = -1
            }else{
                this.swiperActiveIndex = this.$refs.mySwiper.swiper.activeIndex
            }
           
          }
      }
  }
};
</script>
<style lang="less">
*{
    margin:0px;
    padding:0p;
}
a{
    text-decoration: none;
}
img{
    border:0px;
}
li{
    list-style: none;
}
input,textarea,select{
    outline:none;
}
.mauto{
    width:1202px;
    margin:0px auto;
}
.wrap{
    width:100%;
    height:100vh;
    .head{
        width:1200px;
        position: fixed;
        z-index: 9;
        left:50%;
        margin-left:-600px;
        color:white;
        font-size: 17px;
        >div{
            float:right;
        }
        a{
               color:white;
        font-size: 17px; 
        padding-right:30px;
        }
        a+a{
            padding:0px 30px;
        }
    }
    .swiper-container{
        //  background:url('../assets/bg.jpg');
        //  width:100%;
        //  background-position: center;
        //  height:100vh;
    }
    .footer{
        position: fixed;
        width:100vw;
        bottom:0px;
        left:0px;
        z-index: 9;
        background:rgba(0,0,0,0.8);
        height:80px;
        ul{
        
            li{
                float: left;
                width: 300px;
	            height: 80px;
                color:white;
                line-height:80px;
                cursor: pointer;
                text-align: center;
            }
            li:hover{
                background:url('../assets/navChecked_bg.png')
            }
            .checkedNav{
                background:url('../assets/navChecked_bg.png')
            }
        }

    }
}
</style>